// Utility to add branchId to all API calls for Punjab branch
import config from '../config';

/**
 * Add branchId filter to API params
 */
export const addBranchFilter = (params = {}) => {
  return {
    ...params,
    branchId: config.BRANCH_ID
  };
};

/**
 * Add branchId to request body
 */
export const addBranchToBody = (body = {}) => {
  return {
    ...body,
    branchId: config.BRANCH_ID,
    branchName: config.BRANCH_NAME
  };
};

export default { addBranchFilter, addBranchToBody };

